import { ROUTE_MODULE_MAP } from '../constants/route-modules';
import { AppModule } from '@/modules/users/constants/modules';

export const getModuleFromPath = (pathname: string): AppModule | null => {
  const match = ROUTE_MODULE_MAP.find(
    route => pathname === route.path || pathname.startsWith(route.path + '/'),
  );

  return match?.module ?? null;
};
